export default __webpack_public_path__ + "static/media/client-logo-7.a157a500.png";